import React, { memo, useEffect, useState } from 'react';
import { Text, View, StyleSheet, Image } from 'react-native';
import { COLOR, FONT, THEME, __WEB__, bold } from '../../../constants/styles';
import { Container, TurnstileWidget, FormFooter } from '../../components';

import { PENDING, REQUESTING, SUCCESS, FAILED } from '../../../actions/statusTypes';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchAppointmentByCancelToken, cancelAppointment, resetState } from '../scheduler/slice';
import moment from 'moment';

const CancelForm = function CancelForm(props) {
  const [cancelCanceled, setCancelCanceled] = useState(false);
  const [captchaInstance, setCaptchaInstance] = useState(null);

  useEffect(function () {
    props.actions.fetchAppointmentByCancelToken({ token: props.token });
  }, []);

  function doNotCancel() {
    setCancelCanceled(true);
  }
  function doReschedule() {
    props.actions.resetState();
    const locationPath = window.location.pathname.toLowerCase();
    const baseUrl = locationPath.split('cancel')[0];
    window.location = baseUrl;
  }

  function handleCaptchaLoad(captchaInstance) {
    setCaptchaInstance(captchaInstance);
  }
  function handleCaptchaVerify(captchaToken) {
    props.actions.cancelAppointment({ token: props.token, captchaToken });
  }
  function doCancel() {
    captchaInstance.execute();
  }

  function doCancelWithoutCaptcha() {
    props.actions.cancelAppointment({ token: props.token });
  }

  const dateMoment = props.apptToCancel && moment(props.apptToCancel.startDate);
  const isCancellable = props.apptToCancel?.isCancellable;
  return (
    <Container
      errorMessage={props.error?.message}
      style={!!props.isVerticalLayout ? styles.container : null}
      renderActivityOverlay={props.status === REQUESTING}
    >
      <View style={styles.paneWrapper}>
        {!!cancelCanceled ? (
          <View style={styles.contents}>
            <Text style={styles.contentTitle}>Appointment Not Cancelled</Text>
            <Text style={[THEME.textRegular]}>You may now close this browser window</Text>
          </View>
        ) : props.apptToCancel && !isCancellable ? (
          <View style={styles.contents}>
            <Text style={[THEME.textRegular, { marginBottom: 10 }]}>
              You cannot cancel an appointment within {bold('72 hours')} through the Outpatient App.
            </Text>
            <Text style={[THEME.textRegular, { marginBottom: 10 }]}>
              If you cancel your CMR day within 24 hours, you will be marked as a {bold('No Show')}.
            </Text>
            <Text style={[THEME.textRegular, { marginBottom: 10 }]}>
              Please call the CMR Cell Team
              {props.phone && (
                <>
                  {' at '}
                  {bold(props.phone)}
                </>
              )}
              .
            </Text>
          </View>
        ) : !props.apptCanceled && !props.apptToCancel ? (
          <Text style={styles.contentTitle}>Cancel Appointment</Text>
        ) : !props.apptCanceled && !!props.apptToCancel ? (
          <>
            <View style={styles.contents}>
              <Text style={styles.contentTitle}>Cancel Appointment</Text>
              <Text style={[THEME.textRegular, { marginBottom: 10 }]}>
                You want to cancel your {props.apptToCancel.name} on {dateMoment.format('MMMM DD')}{' '}
                at {dateMoment.format('HH:mm')}
              </Text>
              {}
              <View style={styles.captchaContainer}>
                <TurnstileWidget
                  isError={props.status === FAILED}
                  onLoad={handleCaptchaLoad}
                  onVerify={handleCaptchaVerify}
                />
              </View>
            </View>
            <FormFooter
              reverseOrder={true}
              verticalStyle={styles.footerStyleVertical}
              horizontalStyle={styles.footerStyleHorizontal}
              buttonHorizontalStyle={{ marginRight: 15 }}
              onSave={
                !!props.captchaDisabled
                  ? doCancelWithoutCaptcha
                  : !!captchaInstance
                    ? doCancel
                    : null
              }
              saveLabel="Cancel Appointment"
              onCancel={doNotCancel}
              cancelLabel="No, Don't Cancel"
            />
          </>
        ) : (
          <>
            <View style={styles.contents}>
              <Image
                style={{ marginBottom: 40 }}
                source={require('../../../../resources/icon-success-thank-you.png')}
              />
              <Text style={styles.contentTitle}>Appointment Canceled</Text>
              <Text style={[THEME.textRegular, { marginBottom: 40 }]}>
                Would you like to reschedule or request a new appointment?
              </Text>
            </View>
            <FormFooter
              reverseOrder={true}
              verticalStyle={styles.footerStyleVertical}
              horizontalStyle={styles.footerStyleHorizontal}
              onSave={doReschedule}
              saveLabel="Reschedule Appointment"
            />
          </>
        )}
      </View>
    </Container>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  captchaContainer: {
    height: 40,
  },
  paneWrapper: {
    flex: 1,
    maxWidth: 520,
    justifyContent: 'center',
    scrollY: 'auto',
    marginHorizontal: 'auto',
    // backgroundColor: 'pink'
  },
  contents: {
    paddingLeft: 20,
    paddingRight: 10,
  },
  contentTitle: {
    ...FONT.regular,
    color: COLOR.text,
    fontSize: 30,
    marginBottom: 15,
  },
  footerStyleVertical: {
    borderTopWidth: 0,
    backgroundColor: 'transparent',
  },
  footerStyleHorizontal: {
    borderTopWidth: 0,
    justifyContent: 'flex-start',
    paddingLeft: 0,
    backgroundColor: 'transparent',
  },
});

function mapStateToProps(state) {
  return {
    status: state.screens.scheduler.status,
    error: state.screens.scheduler.error,
    apptToCancel: state.screens.scheduler.apptToCancel,
    apptCanceled: state.screens.scheduler.apptCanceled,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { fetchAppointmentByCancelToken, cancelAppointment, resetState },
      dispatch
    ),
  };
}

export default memo(connect(mapStateToProps, mapDispatchToProps)(CancelForm));
